import graphqlClient from '~/graphql/graphqlClient';

export interface MutationUnequipAbilityArgs {
  playerId: string;
  heroHandle: string;
  abilityHandle: string;
  heroBuildId: string;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation UnequipAbility(
  $playerId: String!
  $heroHandle: String!
  $abilityHandle: String!
  $heroBuildId: String!
) {
  unequipAbility(
    playerId: $playerId
    heroHandle: $heroHandle
    abilityHandle: $abilityHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationUnequipAbility(args: MutationUnequipAbilityArgs) {
  return await graphqlClient.request<AbilityChangeResult>('unequipAbility', mutation, args);
}
